import React, {useContext, useEffect, useState} from 'react';
import { Field } from 'react-final-form';
import MuiButton from "@material-ui/core/Button";
import InfoIcon from '@material-ui/icons/Visibility';
import ErrorIcon from '@material-ui/icons/PriorityHigh';
import {usePage} from "@inertiajs/inertia-react";

import RadioButton from './RadioBig';
import Grid from "@material-ui/core/Grid";
import Select from "./Select";
import TextInput from "./TextInput";
import styled from "styled-components";
import SelectCard from "./SelectCard";
import {getCookieValue} from "../utils/getCookieValue";

import { Trans } from "../utils/i18n";
import {useFormState} from "../FormComponents/FormState";


const ProductFound = styled.div`
  display: flex;
  margin-top: 30px;
`;

const ProductFoundHeading = styled.h3`
    margin: 0;
`;

const ProductItem = styled.div`
    transition: background-color .2s,color .2s;
    //border: 2px solid ${props => props.theme.gray};
    border-radius: 5px;
`;

const MarginTop = styled.div`
  margin-top: 15px;
`

const ProductImage = styled.img`
    max-width: 100%;
    border-radius: 30px;
`

const ProblemSelectNiu = React.memo(function ({ values, addCompany, addCoverageId, setAddressId, form }) {
        const orderEntryState = useFormState();
        const { client } = usePage().props;
        const { product, requesttype, serialnumber, problem_1, problem_2, problem_description } = values;
        const selectedProduct = orderEntryState && orderEntryState.products && orderEntryState.products.find(item => String(item.id) === product);

        const faultCodes = selectedProduct && selectedProduct.problems.filter(item => item.type === 'faultcode');

        const categories = selectedProduct && selectedProduct.problems.filter(item => item.type === 'problem');

        const allProblems = selectedProduct && selectedProduct.problems && selectedProduct.problems.reduce((carry, item) => {
            return [
                ...carry,
                ...item.problems,
            ]
        }, []);

        const currentProblem = selectedProduct && selectedProduct.problems && selectedProduct.problems.find(item => parseInt(values.problem_1) === item.id);
        const currentFaultcode = selectedProduct && selectedProduct.problems && selectedProduct.problems.find(item => parseInt(values.faultcode) === item.id);
        const currentProblem2 = allProblems && allProblems.find(item => parseInt(values.problem_2) === item.id);

        if(!selectedProduct || !selectedProduct.problems) {
            return <div></div>
        }

        useEffect(() => {
            if(!currentFaultcode) return;

            if(currentFaultcode.effect === 'stop') {
                form.change('formeffect', 'stop');
            } else {
                form.change('formeffect', null);
            }

            const childProblem = allProblems && allProblems.find(item => currentFaultcode.code_linked === item.code);
            if(!childProblem) return;

            form.change('problem_1', childProblem.problem_id.toString())
            form.change('problem_2', childProblem.id.toString())
        }, [currentFaultcode])

        return (
            <div>
                <div>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={12}>
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={6}>
                                    {
                                        faultCodes && faultCodes.length > 0 &&
                                        <Field
                                            name={'faultcode'}
                                            type={'select'}
                                            component={Select}
                                            field={{
                                                label: <Trans i18nKey="serialNumber.faultcode">Faultcode</Trans>,
                                                titel: <Trans i18nKey="serialNumber.problem.title">123</Trans>,
                                                options: faultCodes.map(problem => ({
                                                    value: problem.id,
                                                    label: `${problem.code} ${problem.name}`,
                                                })),
                                            }}
                                        />
                                    }
                                    <MarginTop>
                                        <Field
                                            name={'problem_1'}
                                            type={'select'}
                                            component={Select}
                                            validate={value => (value ? undefined : <Trans i18nKey="serialNumber.required">Required</Trans>)}
                                            field={{
                                                label: <Trans i18nKey="serialNumber.problemCategory">Problem</Trans>,
                                                titel: <Trans i18nKey="serialNumber.problem.title">123</Trans>,
                                                options: categories.map(problem => ({
                                                    value: problem.id,
                                                    label: problem.name,
                                                })),
                                            }}
                                        />
                                    </MarginTop>
                                    {
                                        currentProblem && currentProblem.problems.length > 0 &&
                                        <MarginTop>
                                            <Field
                                                name={'problem_2'}
                                                type={'select'}
                                                component={Select}
                                                validate={value => (value ? undefined : 'Erforderlich')}
                                                field={{
                                                    label: <Trans i18nKey="serialNumber.problem">Problem</Trans>,
                                                    titel: <Trans i18nKey="serialNumber.problem.title">123</Trans>,
                                                    options: currentProblem.problems.map(problem => ({
                                                        value: problem.id,
                                                        label: problem.name,
                                                    })),
                                                }}
                                            />
                                        </MarginTop>
                                    }
                                </Grid>
                            </Grid>
                            {
                                currentProblem && (currentProblem.problems.length === 0 || values.problem_2) &&
                                <MarginTop>
                                    <Field
                                        name={'problem_description'}
                                        type={'text'}
                                        component={TextInput}
                                        field={{
                                            label: <Trans i18nKey="serialNumber.problemDescription">Problem description</Trans>,
                                        }}
                                    />
                                </MarginTop>
                            }
                            {/*{*/}
                            {/*    currentProblem && (currentProblem.me === 0 || values.problem_2) &&*/}
                            {/*    <MarginTop>*/}
                            {/*        <Field*/}
                            {/*            name={'problem_description'}*/}
                            {/*            type={'text'}*/}
                            {/*            component={TextInput}*/}
                            {/*            field={{*/}
                            {/*                label: <Trans i18nKey="serialNumber.problemDescription">Problem description</Trans>,*/}
                            {/*            }}*/}
                            {/*        />*/}
                            {/*    </MarginTop>*/}
                            {/*}*/}

                            <hr/>

                            <Grid item xs={12} sm={12} style={{marginTop: 30}}>
                                {
                                    currentFaultcode && currentFaultcode.education_text && <div style={{ display: 'flex', 'flexDirection': 'row'}}>
                                        { currentFaultcode.effect === 'stop' ? <ErrorIcon/> : <InfoIcon/> }
                                        <span style={{ marginLeft: 15, marginBottom: 30}}>{ currentFaultcode.education_text }</span>
                                    </div>
                                }
                                {
                                    currentProblem2 && currentProblem2.education_text === 'IW' && <div style={{ display: 'flex', 'flexDirection': 'row'}}>
                                        <ErrorIcon/>
                                        <span style={{ marginLeft: 15, marginBottom: 30}}>
                                            <Trans i18nKey={'serialNumber.problem.iw.educationText'}>
                                                Please provide your details in the form below to allow B2X or a subcontractor of ours to collect your scooter and repair it. Should we identify damaged not covered by warranty, you might be charged by B2X or our subcontractor for the respective amount. You can still reject the repairs but remain liable for the logistics costs.
                                            </Trans>
                                        </span>
                                    </div>
                                }
                                {
                                    currentProblem2 && currentProblem2.education_text === 'OOW' && <div style={{ display: 'flex', 'flexDirection': 'row'}}>
                                        <ErrorIcon/>
                                        <span style={{ marginLeft: 15, marginBottom: 30}}>
                                            <Trans i18nKey={'serialNumber.problem.oow.educationText'}>
                                            Based on your information, the repair is very likely chargeable as it seems not to be covered by warranty. Please see here (link) for the likely costs. The details are evaluated once we receive the scooter and B2X or a subcontractor of ours will get in touch with you. In order to assist best in determining the warranty coverage, please provide more details in the Problem description to support our analysis.
                                            </Trans>
                                        </span>
                                    </div>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </div>
            </div>
        );
},
function areEqual(prevProps, nextProps) {
    return JSON.stringify(prevProps) === JSON.stringify(nextProps);
});

export default ProblemSelectNiu;
